<wd-input-container [name]="name" [classes]="classes()" [label]="label" [helpText]="helpText()" [comments]="comments" [hideComments]="hideComments">
	<input
		[name]="'input' + name"
		type="number"
		class="form-control no-spin"
		min="{{min}}"
		max="{{max}}"
		[(ngModel)]="model"
		#inputValue="ngModel"
		[ngClass]="classes()"
		(mousedown)="onMouseDown($event)"
		(focus)="onFocus($event)"
		(focusout)="onFocusOut()"
		(ngModelChange)="onChange()"
		[readonly]="disabled()"
		[attr.tabindex]="disabled() ? -1 : 0"
		(click)="onClick($event)"
	/>
	<div *ngIf="unit" class="input-group-append">
		<span class="input-group-text unit">{{unit}}</span>
	</div>
</wd-input-container>
